import data from './data';

class Generator {
  constructor() {
    this.btn = document.querySelector("#generate");
    this.bubbleText = document.querySelector(".bubble-text");
    this.bubbleImg = document.querySelector(".bubble-img");
    this.bubble = document.querySelector(".bubble");
    this.init();
  }
  random(arrSize) {
    return Math.floor(Math.random() * arrSize); 
  }
  generateText() {
    return `${data.s1[this.random(data.s1.length)]} ${data.s2[this.random(data.s2.length)]} ${data.s3[this.random(data.s3.length)]} ${data.s4[this.random(data.s4.length)]} ${data.s5[this.random(data.s5.length)]}!`;
  }
  animate(text) {
    if (text.length > 150) this.bubble.classList.add("bubble-bigger");
    else this.bubble.classList.remove("bubble-bigger");
    this.bubbleText.innerHTML = text;
    this.bubble.classList.add("bubble--active");
  }
  prepare() {
    const text = this.generateText();
    if (this.bubble.classList.contains("bubble--active")) {
      this.bubble.classList.remove("bubble--active");
      setTimeout(()=> {
        this.animate(text);
      }, 500);
    } else {
      this.animate(text);
    }
    
    
  }
  init() {
    this.btn.addEventListener("click", ()=> {this.prepare()});
  }
}
new Generator();
